import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import UtilitiesService from '../../services/UtilitiesService'
import CustomAutocomplete from '../../components/Autocomplete'
import CustomSwitch from '../../components/Switch'

interface Props {
    value: string
    setValue: (jobTitle: string) => void
}
const JobTitleFinder = ({ value, setValue }: Props) => {
    const [jobTitles, setJobTitles] = useState<string[] | null>()
    const [filter, setFilter] = useState<string>('')
    const [startsWith, setStartsWith] = useState<boolean>(false)

    useEffect(() => {
        if (!filter) {
            setJobTitles(undefined)
            return
        }

        setJobTitles(null)
        const timeout = setTimeout(() => {
            new UtilitiesService().getJobTitles(filter, startsWith).then((response) => {
                if (response.status !== 200) return
                setJobTitles(response.data)
            })
        }, 1500)

        return () => clearTimeout(timeout)
    }, [filter, startsWith])

    return (
        <div className="flex gap-1 md:gap-2 items-center">
            <CustomAutocomplete
                value={value}
                inputValue={filter}
                options={
                    jobTitles ??
                    (!!filter
                        ? ['Buscando...']
                        : ['Comenzá a buscar, se mostrarán los primeros 10 resultados'])
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Cargo"
                    />
                )}
                getOptionDisabled={(option) =>
                    option === 'Buscando...' ||
                    option === 'Comenzá a buscar, se mostrarán los primeros 10 resultados'
                }
                onInputChange={(e, input) => setFilter(input)}
                onChange={(e, job) => setValue(job ?? '')}
                noOptionsText={jobTitles ? 'No hay resultados' : 'Buscando...'}
                className="md:mr-2 w-full"
            />
            <div className="flex flex-col md:flex-row gap-1 md:gap-2 items-center">
                <CustomSwitch
                    value={startsWith}
                    onChange={(e) => setStartsWith(e.target.checked)}
                />
                <span className="whitespace-nowrap text-[#777777] ml-2 md:ml-0 md:mr-1 text-xs md:text-base">
                    Búsqueda textual
                </span>
            </div>
        </div>
    )
}

export default JobTitleFinder
